import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Reset from "./pages/Reset";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import NoRatings from "./pages/NoRatings";
import AddRating from "./pages/AddRating";
import Rate from "./pages/Rate";
import SideNav from "./components/SideNav";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";



function App() {

  /* const handleScroll = () => {
    const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight
    if (bottom) {
      console.log('at the bottom');
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return 
  }, []); */

  return (
    <div className="app">
      <SideNav />
      <Router>
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/reset" element={<Reset />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/profile" element={<Profile />} />
          <Route exact path="/noratings" element={<NoRatings />} />
          <Route exact path="/add_rating" element={<AddRating />} />
          <Route exact path="/rate/:id" element={<Rate />} />
          <Route exact path="/terms" element={<Terms />} />
          <Route exact path="/privacy" element={<Privacy />} />
        </Routes>
      </Router>
    </div> 
  );
}

export default App;
